var _ = require('underscore'),
  $ = require('jquery'),
  Promise = require('bluebird'),
  React = require('react'),
  ReactDOM = require('react-dom'),
  CamelCase = require('camelcase'),
  ClassNames = require('classnames');

var Glyphicon = require('react-bootstrap/lib/Glyphicon');

var isAutoplaySupported = require('./autoplay.js').default,
  ID3 = require('./id3.js').default,
  CustomPropTypes = require('./types.jsx'),
  Utils = require('./utils.jsx'),
  Callbacks = require('./callbacks.js');

require('jplayer');

var ROLES = [
    'play',
    'pause',
    'toggle',
    'backward',
    'forward',
    'progress-bar',
    'progress-time',
    'track',
    'track-number',
    'track-menu',
    'playlist-menu',
    'volume'
  ],
  ROLE_ACTIONS = {
    backward: {
      onClick: function() {
        Callbacks.call(this, 'backward', 'before');
        this.previous();
        this.play();
        Callbacks.add(this, 'backward', 'after');
      }
    },
    play: {
      onClick: function() {
        if (!this.state.playing) {
          Callbacks.call(this, 'play', 'before');
          this.play();
          Callbacks.add(this, 'play', 'after');
        }
      }
    },
    pause: {
      onClick: function() {
        if (this.state.playing) {
          Callbacks.call(this, 'pause', 'before');
          this.pause();
          Callbacks.add(this, 'pause', 'after');
        }
      }
    },
    toggle: {
      onClick: function() {
        if (this.state.playing) {
          Callbacks.call(this, 'pause', 'before');
          this.pause();
          Callbacks.add(this, 'pause', 'after');
        } else {
          Callbacks.call(this, 'play', 'before');
          this.play();
          Callbacks.add(this, 'play', 'after');
        }
      }
    },
    forward: {
      onClick: function() {
        Callbacks.call(this, 'forward', 'before');
        this.next();
        this.play();
        Callbacks.add(this, 'forward', 'after');
      }
    },
    volume: {
      onChange: function(value) {
        Callbacks.call(this, 'volume', 'before', value);
        this.volume(value);
        Callbacks.add(this, 'volume', 'after', value);
        return value;
      }
    },
    'track-menu': {
      onSelect: function(value) {
        Callbacks.call(this, 'track', 'before', value);
        this.track(value);
        this.play();
        Callbacks.add(this, 'track', 'after', value);
        return value;
      }
    },
    'playlist-menu': {
      onSelect: function(value) {
        Callbacks.call(this, 'playlist', 'before', value);
        this.playlist(value);
        this.play();
        Callbacks.add(this, 'playlist', 'after', value);
        return value;
      }
    },
    'progress-bar': {
      onChange: function(value) {
        Callbacks.call(this, 'progress', 'before', value);
        this.seek(value);
        Callbacks.add(this, 'progress', 'after', value);
        return value;
      }
    }
  },
  EXTRACTORS = _.map(ROLES, function(role) {
    return {
      key: role,
      test: function(child) {
        if (!child || !child.props || !child.props.role) return false;
        return child.props.role == role;
      },
      refine: function(component, child) {
        var props = _.extend({}, component.state, child.props);
        _.each(['onClick', 'onChange', 'onSelect'], function(key) {
          if (ROLE_ACTIONS[role] && ROLE_ACTIONS[role][key]) {
            props[key] = _.compose(
              _.bind(child.props[key] || function() {}, component),
              _.bind(ROLE_ACTIONS[role][key] || function() {}, component)
            );
          } else {
            props[key] = _.bind(child.props[key] || function() {}, component);
          }
        });
        return React.cloneElement(child, props, child.props.children);
      }
    };
  });

function defaultRefine(component, child) {
  if (!child) return null;
  var props = _.extend({}, component.state, child.props);
  _.each(['onClick', 'onChange', 'onSelect'], function(key) {
    props[key] = _.bind(props[key] || function() {}, component);
  });
  return React.cloneElement(child, props, child.props.children);
}

function refineChildren(component, children) {
  return React.Children.map(children, function(child) {
    var extractor = _.find(EXTRACTORS, function(extractor) {
      return extractor.test(child);
    });
    if (extractor) {
      child = extractor.refine(component, child);
    } else {
      child = defaultRefine(component, child);
    }
    return child;
  });
}

var Player = React.createClass({
  propTypes: {
    playlists: CustomPropTypes.PlaylistsType.isRequired,
    playlist: React.PropTypes.number,
    track: React.PropTypes.number,
    play: React.PropTypes.bool,
    loop: React.PropTypes.bool,
    initialVolume: React.PropTypes.number,
    defaultTrackImage: React.PropTypes.string,

    // JPlayer options
    supplied: React.PropTypes.string,
    swfPath: React.PropTypes.string,

    // Callbacks
    onAutoplayAborted: React.PropTypes.func,
    onBeforePlay: React.PropTypes.func,
    onAfterPlay: React.PropTypes.func,
    onBeforePause: React.PropTypes.func,
    onAfterPause: React.PropTypes.func,
    onBeforeForward: React.PropTypes.func,
    onAfterForward: React.PropTypes.func,
    onBeforeBackward: React.PropTypes.func,
    onAfterBackward: React.PropTypes.func,

    // Normal
    className: CustomPropTypes.ClassNameType
  },
  getDefaultProps: function() {
    return {
      playlists: [],
      playlist: -1,
      track: -1,

      // JPlayer options
      supplied: 'mp3',
      swfPath: '/jquery.jplayer.swf',
      initialVolume: 80,

      // Callbacks
      onAutoplayAborted: function() {},
      onBeforePlay: function() {},
      onAfterPlay: function() {},
      onBeforePause: function() {},
      onAfterPause: function() {},
      onBeforeForward: function() {},
      onAfterForward: function() {},
      onBeforeBackward: function() {},
      onAfterBackward: function() {}
    };
  },
  getInitialState: function() {
    return {
      playing: false,
      loading: true,
      playlists: [],
      playlist: -1,
      track: -1,
      time: -1,
      duration: -1,
      seekPercentage: -1,
      timePercentage: -1,
      volume: -1
    };
  },
  componentWillMount: function() {
    var self = this;

    var playlist = this.props.playlist;
    if (!~this.props.playlist) {
      if (this.props.playlists.length > 0) {
        playlist = 0;
      }
    } else {
      if (this.props.playlist >= this.props.playlists.length) {
        playlist = 0;
      }
    }

    var track = this.props.track;
    if (!~this.props.track) {
      if (this.props.playlists[playlist].playlist.length > 0) {
        track = 0;
      }
    } else {
      if (this.props.track >= this.props.playlists[playlist].playlist.length) {
        track = 0;
      }
    }

    this.setState({
      track: track,
      playlist: playlist,
      playlists: this.props.playlists,
      volume: this.props.initialVolume
    });
  },
  componentDidMount: function() {
    var self = this;

    Promise.join(
      this.fetchID3Tags(
        self.getPlaylist().playlist,
        self.props.defaultTrackImage
      ),
      this.setupJPlayer()
    )
      .spread(function(fullPlaylist) {
        self.state.playlists[self.state.playlist].playlist = fullPlaylist;
        self.setState({ playlists: self.state.playlists });
        return isAutoplaySupported();
      })
      .tap(function(autoplaySupported) {
        if (self.props.play) {
          if (autoplaySupported) {
            self.play();
          } else {
            self.props.onAutoplayAborted();
          }
        }
      })
      .catch(function(err) {
        console.error(err);
      })
      .finally(function() {
        self.setState({ loading: false });
      });
  },
  componentWillReceiveProps: function(nextProps) {
    if (
      nextProps.playlists &&
      nextProps.playlists.length &&
      !_.isEqual(this.props.playlists, nextProps.playlists)
    ) {
      this.setState({ playlists: nextProps.playlists, playlist: 0, track: 0 });
    }

    if (nextProps.playlist && ~nextProps.playlist) {
      this.playlist(nextProps.playlist);
      this.postPlaylistUpdate(nextProps.playlist);
    }

    if (nextProps.track && ~nextProps.track) {
      this.track(nextProps.track);
      this.postTrackUpdate(this.state.playlist, nextProps.track);
    }

    if (nextProps.play) {
      this.play();
    }

    if (nextProps.pause) {
      this.pause();
    }
  },
  shouldComponentUpdate: function(nextProps, nextState) {
    return !nextState.loading;
  },
  componentDidUpdate: function(prevProps, prevState) {
    var self = this,
      updatePlaylists = !_.isEqual(prevState.playlists, this.state.playlists),
      updatePlaylist = prevState.playlist != this.state.playlist,
      updateTrack = prevState.track != this.state.track;

    if (updatePlaylists) {
      this.setState({ playlist: 0, track: 0 });
    }

    if (updatePlaylist) {
      this.postPlaylistUpdate(this.state.playlist);
    }

    if (updateTrack) {
      this.postTrackUpdate(this.state.playlist, this.state.track);
    }

    // Flush all existing callbacks after player updates.
    Callbacks.flush();
  },
  render: function() {
    var classes = Utils.ClassNames(
        'player',
        'player-fixed-bottom',
        this.props.className
      ),
      children = null;
    if (!this.state.loading) {
      children = refineChildren(this, this.props.children);
    }
    return (
      <div className={ClassNames(classes)} ref="player">
        <div css={{ display: 'none' }} ref="controller" />
        {children}
      </div>
    );
  },

  setupJPlayer: function() {
    var self = this,
      controller = $(ReactDOM.findDOMNode(this.refs.controller));
    return new Promise(function(resolve, reject) {
      controller.jPlayer({
        ready: function() {
          resolve();
        },
        ended: function() {
          self.setState({ playing: false });
          self.next();
        },
        play: function() {
          self.setState({ playing: true });
          $(this).jPlayer('pauseOthers');
        },
        pause: function() {
          self.setState({ playing: false });
        },
        timeupdate: function(event) {
          self.updateStatus(event.jPlayer.status);
        },
        loadeddata: function(event) {
          self.updateStatus(event.jPlayer.status);
        },
        progress: function(event) {
          self.updateStatus(event.jPlayer.status);
        },
        swfPath: self.props.swfPath,
        supplied: self.props.supplied
      });

      var track = self.getTrack();
      if (track) {
        controller.jPlayer('setMedia', {
          title: track.name,
          mp3: track.url
        });
      }
    });
  },
  postPlaylistUpdate: function(playlist) {
    var self = this;
    this.fetchID3Tags(
      this.state.playlists[playlist].playlist,
      self.props.defaultTrackImage
    )
      .then(function(fullPlaylist) {
        self.state.playlists[playlist].playlist = fullPlaylist;
        self.setState({ playlists: self.state.playlists, track: 0 });
      })
      .catch(function(err) {
        console.error(err);
        this.setState({ track: 0 });
      });

    this.postTrackUpdate(playlist, 0);
  },
  postTrackUpdate: function(playlist, track) {
    // new track selected
    var _track = this.state.playlists[playlist].playlist[track];
    $(ReactDOM.findDOMNode(this.refs.controller)).jPlayer('setMedia', {
      title: _track.name,
      mp3: _track.url
    });
    this.play();
  },
  updateStatus: function(status) {
    this.setState({
      time: status.currentTime,
      duration: status.duration,
      seekPercentage: status.seekPercent,
      timePercentage: status.currentPercentAbsolute
    });
  },
  previous: function() {
    if (this.state.track > 0) {
      this.setState({ track: this.state.track - 1 });
    }
  },
  next: function() {
    if (this.state.track < this.getPlaylist().playlist.length - 1) {
      this.setState({ track: this.state.track + 1 });
    } else if (this.props.loop) {
      this.setState({ track: 0 });
    }
  },
  track: function(track) {
    if (track >= 0 && track < this.getPlaylist().playlist.length) {
      this.setState({ track: track });
    }
  },
  playlist: function(playlist) {
    if (playlist >= 0 && playlist < this.state.playlists.length) {
      this.setState({ playlist: playlist });
    }
  },
  play: function() {
    $(ReactDOM.findDOMNode(this.refs.controller)).jPlayer('play');
  },
  pause: function() {
    $(ReactDOM.findDOMNode(this.refs.controller)).jPlayer('pause');
  },
  seek: function(seekPercent) {
    $(ReactDOM.findDOMNode(this.refs.controller)).jPlayer(
      'playHead',
      seekPercent
    );
  },
  volume: function(percent) {
    this.setState({ volume: percent });
    $(ReactDOM.findDOMNode(this.refs.controller)).jPlayer(
      'volume',
      percent / 100
    );
  },

  fetchID3Tags: function(playlist, defaultImage) {
    var self = this;
    if (!self.id3) {
      self.id3 = new ID3(defaultImage);
    }
    return Promise.map(_.pluck(playlist, 'url'), function(uri) {
      return self.id3.get(uri).catch(function(error) {
        console.error(uri, error);
        return {};
      });
    })
      .then(function(formattedTags) {
        return _.zip(playlist, formattedTags);
      })
      .map(function(playlistItem) {
        return _.extend({}, playlistItem[1], playlistItem[0]);
      });
  },
  getPlaylist: function() {
    return this.state.playlists[this.state.playlist];
  },
  getTrack: function() {
    return this.getPlaylist().playlist[this.state.track];
  },
  status: function() {
    return this.state;
  }
});

module.exports = Player;



// WEBPACK FOOTER //
// ./src/app/components/player.jsx